import styled from '@emotion/styled';

import Flex from 'components/util/Flex';

import { SMainWrapper } from '../../shared/style';

export default function RevenuePolicy() {
  return (
    <SMainWrapper>
      <h3 style={{ marginBottom: '40px' }}>창작자 이용약관</h3>
      <SMainContainer>
        <div>
          본 약관(이하 “약관”)은 주식회사 버블탭(“회사”, “플랫폼 서비스 제공자” 또는 “PSP”)과 PSP의 이용약관 (이하
          “이용약관”) 제2조에 정의한 이용자 또는 회원 중 리워드 프로그램 대상 회원 (이하 “창작자”) 간의 약관으로, PSP
          플랫폼을 통해 발생하는 수익을 창작자와 PSP 간에 배분하기 위한 조건과 내용을 규정합니다.
        </div>
        <div>
          <SSubTitle>제1조: 일반 규정</SSubTitle>
          <SSubWrapper direction="column">
            <SSubContainer>
              <SSubNumberTitle>① 목적</SSubNumberTitle>
              <span>
                본 약관의 목적은 PSP 플랫폼에서 창작자가 PSP의 서비스를 이용하면서 생성한 AI 캐릭터, 세계관 및 씬(이하
                “컨텐츠”)로부터 발생한 유료 구매에 대한 수익을 PSP와 창작자 간에 배분하는 조건 및 파생사업(제4조의2에서
                정의함)과 관련된 사항을 규정하는 것입니다.
              </span>
            </SSubContainer>
            <SSubContainer>
              <SSubNumberTitle>② 약관의 우선 적용</SSubNumberTitle>
              <span>
                리워드 프로그램 운영 및 사용시 본 약관과 PSP의 이용 약관 간에 충돌이 발생할 경우, 본 약관이 우선
                적용됩니다.
              </span>
            </SSubContainer>
          </SSubWrapper>
        </div>
        <div>
          <SSubTitle>제2조: 약관 범위</SSubTitle>
          <SSubWrapper direction="column">
            <SSubContainer>
              <SSubNumberTitle>① 창작자의 컨텐츠</SSubNumberTitle>
              <span>
                창작자는 PSP의 서비스 및 제반 기술을 사용하여 AI 컨텐츠를 생성할 수 있으며, 이는 플랫폼에서 제공되는
                사전 정의된 템플릿과 프롬프트를 활용해 제작됩니다. 창작자가 제작, 생성한 컨텐츠에 대한 저작권의 범위는
                이용약관 16조에서 규정한 “회원의 게시물”에 대한 저작권의 범위에 준하여 적용됩니다.
              </span>
            </SSubContainer>
            <SSubContainer>
              <SSubNumberTitle>② 이용자 또는 회원의 창작자의 컨텐츠 사용 </SSubNumberTitle>
              <span>
                다른 이용자 또는 회원은 창작자의 컨텐츠와의 대화, 챗, 롤플레이 등의 방법으로 컨텐츠를 다양하게 사용할 수
                있습니다. 이는 PSP 플랫폼의 수익 창출 방법 중 하나입니다.
              </span>
            </SSubContainer>
          </SSubWrapper>
        </div>
        <div>
          <SSubTitle>제3조: 수익 분배 규정</SSubTitle>
          <SSubWrapper direction="column">
            <SSubContainer>
              <SSubNumberTitle>① 정의</SSubNumberTitle>
              <SListContainer direction="column">
                <span>
                  1. “수익배분대상 애셋”이란 리워드 프로그램에 따라 수익 배분의 대상이 되는, 창작자가 생성한 컨텐츠(AI
                  캐릭터, 세계관, 씬 등)를 말합니다.
                </span>
                <span>2. “결제 금액”이란 이용자가 수익배분대상 애셋을 사용하기 위하여 지불한 총액을 말합니다.</span>
                <span>3. “직접 비용”이란 결제 금액에서 공제되는 다음 각 목의 비용을 말합니다.</span>
                <SListContainer direction="column">
                  <span>가. 결제대행 및 앱마켓 수수료</span>
                  <span>나. 서버·인프라 운영 비용</span>
                  <span>다. 모델 추론(inference) 비용</span>
                  <span>라. 그 밖에 수익 창출에 직접 소요되어 회사가 정하는 비용</span>
                  <span>
                    공유 비용의 애셋별 배분 방법 및 구체적 산정식은 리워드 대시보드(제6조)에 공개하는 정책에 따릅니다.
                  </span>
                </SListContainer>
                <span>
                  4. “정산대상 순이익”이란 결제 금액에서 부가가치세를 제외한 금액에서 다시 직접 비용을 공제한, 해당
                  수익배분대상 애셋에 귀속되는 금액을 말합니다. 본 용어는 본 약관상 정의된 개념으로서 회계상
                  당기순이익과는 다릅니다.
                </span>
                <span>
                  5. “리워드”란 정산대상 순이익에 회사(PSP)가 정하는 비율을 적용하여 창작자에게 지급하는 금액을
                  말합니다.
                </span>
                <span>
                  6. 본 약관에서 정한 창작자의 수익은 서비스 화면에서 “리워드”로 표기됩니다. 본 약관에서 “수익” 또는
                  “수익 배분”이 창작자에게 지급되는 금액을 의미하는 경우, 이는 “리워드”와 같은 의미입니다.
                </span>
              </SListContainer>
            </SSubContainer>
            <SSubContainer>
              <SSubNumberTitle>② 수익 배분 비율</SSubNumberTitle>
              <span>
                PSP는 창작자가 생성한 수익배분대상 애셋을 회원 또는 이용자가 사용함으로써 발생한 정산대상 순이익에
                회사(PSP)가 정하는 비율을 적용한 금액을 리워드로 창작자에게 배분합니다. 해당 비율은 PSP가 정하며, 모든
                회원에게 일괄적으로 적용되지 않을 수 있습니다. PSP는 각 창작자에게 본인에게 적용되는 비율을 명시할
                의무가 있습니다.
              </span>
            </SSubContainer>
            <SSubContainer>
              <SSubNumberTitle>③ 라이선스에 대한 대가</SSubNumberTitle>
              <span>
                제3조에 명시된 수익 배분 조항은 창작자가 PSP에게 이용약관 제16조 및 본 약관 제4조에 따라 제공한 제한적
                사용권 또는 라이선스에 대한 대가로 간주됩니다(약관 제5조 참조).
              </span>
            </SSubContainer>
            <SSubContainer>
              <SSubNumberTitle>④ 다수 창작자의 참여</SSubNumberTitle>
              <span>
                단일 대화, 챗, 또는 사용에 다수의 창작자의 컨텐츠가 연관된 경우, 수익 배분은 PSP의 독점적인 수익 분배
                방법에 따라 이루어지며 PSP가 공정하게 관리합니다.
              </span>
            </SSubContainer>
            <SSubContainer>
              <SSubNumberTitle>⑤ 지급 일정</SSubNumberTitle>
              <span>
                수익 배분은 매월 15일에 정산되며 25일에 지급됩니다. 해당 월 15일 이전에 출금 신청한 수익은 당월 25일에
                지급됩니다. 해당 월 15일 또는 그 이후에 출금 신청한 수익은 익월 25일에 지급됩니다.
              </span>
            </SSubContainer>
            <SSubContainer>
              <SSubNumberTitle>⑥ 세금 및 공제</SSubNumberTitle>
              <span>
                모든 수익 배분은 대한민국 세법에 따른 세금 공제를 받습니다. 창작자는 자신의 관할 지역에서 세금 의무를
                준수할 책임이 있으며 PSP는 창작자의 세금 관련 일절 책임을 지지 않습니다.
              </span>
            </SSubContainer>
            <SSubContainer>
              <SSubNumberTitle>⑦ 약관에서 배제되는 수익</SSubNumberTitle>
              <SListContainer direction="column">
                <span>
                  1. PSP가 다양한 이벤트, 행사, 등을 통해 지급되거나 서비스를 운영하면서 지급된 무료 또는 보너스 재화를
                  통해 창작자의 컨텐츠를 사용할 경우, 해당 금액은 수익 분배 대상에서 제외됩니다.{' '}
                </span>
                <span>
                  2. PSP가 서비스를 제공하면서 제2조, 2항에 해당이 안되는 활동으로 수익이 창출될 수 있습니다. 해당
                  수익은 PSP와 창작자 간 분배의 대상에서 제외됩니다.
                </span>
              </SListContainer>
            </SSubContainer>
            <SSubContainer>
              <SSubNumberTitle>⑧ 수익 배분 내부 재화 전환</SSubNumberTitle>
              <SListContainer direction="column">
                <span>
                  1. 창작자는 수익 배분의 전부 또는 일부를 회사의 내부 재화 (이용약관 제2조 정의)로 PSP가 정한 절차와
                  정책에 따라 전환할 수 있습니다.
                </span>
                <span>
                  2. 창작자 수익 배분의 회사 내부 재화 전환 관련 절차와 정책은 리워드 프로그램
                  대시보드(reward.bubblechat.ai/dashboard)에서 확인할 수 있으면 PSP는 해당 절차와 정책을 본 약관 개정
                  없이 수정 또는 업데이트할 수 있습니다.
                </span>
                <span>3. 창작자가 본인의 수익 배분을 회사의 내부 재화로 전환할 경우:</span>
                <SListContainer direction="column">
                  <span>
                    a. 전환 가능한 내부 재화는 본 약관 제3조 6항에 따라 모든 세금을 정산한 값인 것을 창작자가 인지하고
                    인정합니다.
                  </span>
                  <span>
                    b. 창작자가 본인의 수익 배분을 회사의 내부 재화로 전환할 경우 해당 내부 재화는 현금, 신용카드, 은행
                    이체, 등 타 수단으로 환불이 불가능합니다.
                  </span>
                </SListContainer>
                <span>
                  4. 창작자 수익 배분의 회사 내부 재화로의 전환 관련 PSP의 절차 또는 정책을 어길 경우 창작자의 계정은
                  정지 또는 삭제될 수 있으며 회사는 적합한 법 절차를 이행합니다.
                </span>
              </SListContainer>
            </SSubContainer>
            <SSubContainer>
              <SSubNumberTitle>⑨ 회원 탈퇴</SSubNumberTitle>
              <SListContainer direction="column">
                <span>
                  회원 탈퇴시 리워드 프로그램으로 창작자에게 발생한 수익 배분은 모두 회원 탈퇴일로부터 소멸됩니다.
                  소멸된 수익 배분은 복구되지 않습니다.
                </span>
              </SListContainer>
            </SSubContainer>
          </SSubWrapper>
        </div>
        <div>
          <SSubTitle>제4조: 라이선스 및 지적 재산권</SSubTitle>
          <SSubWrapper direction="column">
            <SSubContainer>
              <SSubNumberTitle>① PSP에 대한 제한적 사용권 및 라이선스</SSubNumberTitle>
              <span>
                창작자는 PSP 플랫폼에서 컨텐츠를 생성함으로써 PSP에 제한적이고 전 세계적인 라이선스를 부여합니다. PSP는
                본 약관 및 이용약관에 따라 창작자의 컨텐츠를 주식회사 버블탭, PSP, 회사의 현재 및 미래 서비스에 사용할
                권리를 가집니다.
              </span>
            </SSubContainer>
            <SSubContainer>
              <SSubNumberTitle>② 권리의 유지</SSubNumberTitle>
              <span>
                창작자는 컨텐츠에 대한 소유권을 유지하나, PSP가 본 약관과 이용약관에 따라 컨텐츠를 활용할 수 있도록
                허용합니다.
              </span>
            </SSubContainer>
            <SSubContainer>
              <SSubNumberTitle>③ 저작권 침해 컨텐츠의 삭제 또는 비공개 처리</SSubNumberTitle>
              <span>
                창작자의 컨텐츠가 제3자의 지적 재산권을 침해한 컨텐츠로 판단 또는 신고될 경우 PSP는 사전 통보 없이 해당
                컨텐츠를 삭제 또는 비공개 처리할 권리를 가집니다. 삭제 또는 비공개 처리 후 PSP는 창작자에게 해당 조치에
                대해 통보합니다.
              </span>
            </SSubContainer>
            <SSubContainer>
              <SSubNumberTitle>④ 다수의 침해 사례 </SSubNumberTitle>
              <span>
                반복적인 지적 재산권 침해 신고가 접수된 계정은 PSP의 재량에 따라 일시 중단되거나 영구 삭제될 수
                있습니다.
              </span>
            </SSubContainer>
            <SSubContainer>
              <SSubNumberTitle>⑤ 미청구 수익의 몰수</SSubNumberTitle>
              <span>
                지적 재산권 침해로 인해 발생한 수익은 몰수됩니다. 창작자는 이러한 위반으로 인해 발생하는 모든 청구에
                대해 PSP를 면책합니다.
              </span>
            </SSubContainer>
          </SSubWrapper>
        </div>
        <div>
          <SSubTitle>제4조의2: 파생사업에 관한 회사의 권리</SSubTitle>
          <SSubWrapper direction="column">
            <SSubContainer>
              <SSubNumberTitle>① 정의</SSubNumberTitle>
              <span>
                본 조에서 “파생사업”이란 창작자의 컨텐츠(AI 캐릭터, 세계관, 씬 등)를 원작 또는 소재로 하여
                매체·형식·기술을 불문하고 이루어지는 일체의 2차적 저작물 또는 상품의 제작과 관련된 사업을 의미하며,
                출판, 영상화, 게임, 음원·음성, 굿즈·머천다이징, 라이선싱, 공연·전시 등을 포함하되 이에 한정되지
                않습니다.
              </span>
            </SSubContainer>
            <SSubContainer>
              <SSubNumberTitle>② 적용 대상</SSubNumberTitle>
              <span>
                본 조는 리워드 프로그램에 참여하여 회사로부터 수익 배분을 받는 창작자에 한하여 적용됩니다. 본 조에 따라
                회사가 보유하는 권리는 회사가 창작자에게 제공하는 수익 배분 및 플랫폼 가치(제5조)에 대한 대가로서
                부여됩니다.
              </span>
            </SSubContainer>
            <SSubContainer>
              <SSubNumberTitle>③ 우선협상권 및 우선거절권</SSubNumberTitle>
              <span>
                창작자는 자신의 컨텐츠에 관한 파생사업에 대하여 회사에 우선협상권 및 우선거절권을 부여합니다. 이에 따라
                회사는 (1) 창작자의 컨텐츠를 기반으로 한 파생사업을 우선적으로 추진·협상할 권리, (2) 창작자가 회사가
                아닌 제3자와 파생사업을 진행하고자 할 경우 동일한 조건으로 제3자에 우선하여 파생사업을 진행할 권리를
                가집니다. 본 조의 권리는 창작자의 컨텐츠에 대한 소유권 및 저작권(2차적저작물작성권을 포함합니다)의
                양도를 의미하지 아니하며, 해당 권리는 창작자에게 유보됩니다.
              </span>
            </SSubContainer>
            <SSubContainer>
              <SSubNumberTitle>④ 행사 절차 및 기간</SSubNumberTitle>
              <SListContainer direction="column">
                <span>
                  1. 창작자가 제3자와 파생사업을 진행하고자 하거나 제3자로부터 파생사업 제안을 받은 경우, 창작자는 즉시
                  그 주요 조건을 회사에 서면(전자문서를 포함합니다)으로 통지하여야 합니다.
                </span>
                <span>
                  2. 회사는 통지를 받은 날부터 14일 이내에 우선권 행사 여부를 통지하며, 회사가 우선권을 행사하는 경우
                  당사자는 그 통지일부터 45일 이내에 성실히 본계약 체결을 위한 협상에 임합니다.
                </span>
                <span>
                  3. 창작자는 위 14일의 회신 기간 및 회사가 우선권을 행사한 경우의 45일 협상 기간 동안 동일한 파생사업에
                  관하여 제3자와 협의나 협상을 하지 않아야 하며, 합의 혹은 계약을 체결하지 않아야 합니다.
                </span>
                <span>
                  4. 본 조에 따른 우선권은 창작자의 리워드 프로그램 참여 기간 및 그 종료일부터 1년간 존속합니다.
                </span>
              </SListContainer>
            </SSubContainer>
            <SSubContainer>
              <SSubNumberTitle>⑤ 수익 배분</SSubNumberTitle>
              <span>
                창작자는 파생사업의 원작 지식재산(컨텐츠)을 제공하는 원작 라이선서의 지위에서 그 대가를 받습니다. 2차
                저작물 또는 상품의 제작·제조에 소요되는 일체의 비용은 회사 또는 제작 주체가 부담하며, 창작자에게
                지급되는 원작 사용료(라이선스 수수료)는 해당 제작 원가를 반영하여 산정됩니다. 파생사업의 수익 배분 및
                보상은 본 약관과 별개의 개별 계약으로 정하되, 아래 [별표]의 영역별 원작 라이선스 수수료의 지급 범위를
                참고하여 결정합니다. 본 항의 파생사업 수익 배분에 관하여는 제3조 제7항에 우선하여 본 조를 적용합니다.
              </span>
            </SSubContainer>
            <SSubContainer>
              <SSubNumberTitle>⑥ 위반 시 효과</SSubNumberTitle>
              <span>
                창작자가 제4항의 통지 의무 또는 거래 보류 의무를 위반하여 회사의 우선권을 침해한 경우, 회사는 그로
                인하여 발생한 손해의 배상을 청구할 수 있습니다.
              </span>
            </SSubContainer>
            <SSubContainer>
              <SSubNumberTitle>⑦ 창작자 권리의 유지</SSubNumberTitle>
              <span>
                본 조는 이용약관 제16조 및 본 약관 제4조에 따른 창작자의 컨텐츠에 대한 소유권을 변경하지 아니합니다.
                회사가 제4항의 기간 내에 우선권을 행사하지 아니하거나 협상 기간 내에 합의에 이르지 못한 경우, 창작자는
                회사에 통지한 조건과 실질적으로 동일한 조건으로 제3자와 파생사업을 진행할 수 있습니다.
              </span>
            </SSubContainer>
            <SSubContainer>
              <SSubNumberTitle>⑧ 분리 가능성 및 효력 유지</SSubNumberTitle>
              <span>
                본 조의 일부가 약관규제법 등 관련 법령에 따라 무효이거나 집행 불가능한 것으로 판단되는 경우에도, 회사의
                우선협상권을 포함한 나머지 조항은 법령이 허용하는 최대 범위에서 유효하게 존속하며, 무효로 판단된 부분은
                그 취지에 가장 부합하는 적법한 내용으로 축소하여 적용됩니다.
              </span>
            </SSubContainer>
            <SSubContainer>
              <SSubNumberTitle>⑨ 회사의 파생사업 제안</SSubNumberTitle>
              <span>
                회사는 창작자의 컨텐츠와 관련된 파생사업을 추진할 것을 창작자에게 제안할 수 있으며, 그러한 경우 창작자는
                신의에 따라 성실히 회사와의 파생사업 추진에 대한 협의에 임하여야 합니다.
              </span>
            </SSubContainer>
            <SSubContainer>
              <SSubNumberTitle>
                [별표] 영역별 원작 IP 라이선스 수수료 지급 범위 (창작자 = 원작 라이선서 기준)
              </SSubNumberTitle>
              <STableWrapper>
                <STable>
                  <caption>영역별 원작 IP 라이선스 수수료 지급 범위</caption>
                  <thead>
                    <tr>
                      <th scope="col">영역</th>
                      <th scope="col">창작자(원작 IP) 몫의 성격·지급 범위</th>
                      <th scope="col">제작 원가 부담 주체</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>굿즈·머천다이징</td>
                      <td>IP 라이선서 로열티 = 순매출의 약 5~15%</td>
                      <td>제조사(제조 원가·유통)</td>
                    </tr>
                    <tr>
                      <td>출판(소설·라이트노벨)</td>
                      <td>원작 사용료 — 정가/순매출의 소수 비율 또는 정액 판권료</td>
                      <td>출판사·집필 작가</td>
                    </tr>
                    <tr>
                      <td>웹툰화(노블코믹스형)</td>
                      <td>원작(글) 라이선서 몫 = 웹툰 순수익의 소수 비율(건별, 한 자릿수~십수 %대)</td>
                      <td>작화가·웹툰 스튜디오</td>
                    </tr>
                    <tr>
                      <td>영상화(드라마·영화·애니)</td>
                      <td>정액 판권료(±옵션료) 중심, 흥행 시 소액 백엔드(RS)</td>
                      <td>제작사·OTT</td>
                    </tr>
                    <tr>
                      <td>게임·인터랙티브</td>
                      <td>매출 연동 로열티(소수 %), 건별 협상</td>
                      <td>개발사</td>
                    </tr>
                  </tbody>
                </STable>
              </STableWrapper>
            </SSubContainer>
          </SSubWrapper>
        </div>
        <div>
          <SSubTitle>제5조: 대가와 가치 교환</SSubTitle>
          <SSubWrapper direction="column">
            <SSubContainer>
              <SSubNumberTitle>① 라이선스에 대한 대가</SSubNumberTitle>
              <span>
                제3조에 명시된 수익 배분 조항은 창작자가 PSP에 제공한 제한적 사용권 또는 라이선스에 대한 적절하고 충분한
                대가로 간주됩니다.
              </span>
            </SSubContainer>
            <SSubContainer>
              <SSubNumberTitle>② 플랫폼의 가치</SSubNumberTitle>
              <span>
                창작자는 PSP 플랫폼이 제공하는 알고리즘, 템플릿, 회원 및 이용자들 등이 컨텐츠 수익화에 중요한 가치를
                제공한다는 점을 인정합니다.
              </span>
            </SSubContainer>
          </SSubWrapper>
        </div>
        <div>
          <SSubTitle>제6조: 창작자에게 수익 보고</SSubTitle>
          <SSubWrapper direction="column">
            <SSubContainer>
              <SSubNumberTitle>① 수익 보고</SSubNumberTitle>
              <span>
                수익 보고서는 PSP의 온라인 대시보드 reward.bubblechat.ai/dashboard에서 확인할 수 있습니다. 창작자는
                정기적으로 해당 보고서를 검토할 책임이 있습니다.
              </span>
            </SSubContainer>
            <SSubContainer>
              <SSubNumberTitle>② 보고의 정확성</SSubNumberTitle>
              <span>
                PSP는 보고서의 정확성을 보장하기 위해 노력하나, 창작자가 인지한 오류 발생 10일 이내에 해당 건에 대해
                PSP에 보고해야 합니다.
              </span>
            </SSubContainer>
            <SSubContainer>
              <SSubNumberTitle>③ 플랫폼 장애에 대한 면책</SSubNumberTitle>
              <span>
                PSP는 플랫폼 다운타임, 기술적 문제, 기타 외부 요인으로 인한 수익 손실에 대해 책임을 지지 않습니다.
              </span>
            </SSubContainer>
          </SSubWrapper>
        </div>
        <div>
          <SSubTitle>제7조: 계정 관리 및 비활성 상태</SSubTitle>
          <SSubWrapper direction="column">
            <SSubContainer>
              <SSubNumberTitle>① 비활성 계정</SSubNumberTitle>
              <span>2년간 활동이 없는 계정은 비활성 계정으로 간주됩니다.</span>
            </SSubContainer>
            <SSubContainer>
              <SSubNumberTitle>② 수익의 회수</SSubNumberTitle>
              <span>
                비활성 계정에 누적된 수익은 PSP로 귀속됩니다. PSP는 계정을 비활성 상태로 지정하기 1개월, 1주, 1일 전에
                창작자에게 알림을 보냅니다.
              </span>
            </SSubContainer>
          </SSubWrapper>
        </div>
        <div>
          <SSubTitle>제8조: 기밀 유지</SSubTitle>
          <SSubWrapper direction="column">
            <SSubContainer>
              <SSubNumberTitle>① 기밀 유지의 범위</SSubNumberTitle>
              <span>
                창작자는 수익 배분 과정에서 얻은 모든 정보를 기밀로 유지해야 합니다. 여기에는 독점 알고리즘, 수익 배분
                방법론, 플랫폼 운영 정보 및 기타 사업 기밀이 포함됩니다.
              </span>
            </SSubContainer>
            <SSubContainer>
              <SSubNumberTitle>② 정보 보호</SSubNumberTitle>
              <span>
                창작자는 PSP의 정보를 보호하기 위해 합리적인 조치를 취해야 하며, 무단 공개는 중대한 계약 위반으로
                간주됩니다.
              </span>
            </SSubContainer>
          </SSubWrapper>
        </div>
        <div>
          <SSubTitle>제9조: 책임 및 면책</SSubTitle>
          <SSubWrapper direction="column">
            <SSubContainer>
              <SSubNumberTitle>① 플랫폼 보안</SSubNumberTitle>
              <span>
                창작자는 자신의 계정을 보호할 책임이 있으며, 계정 무단 접근으로 인한 수익 손실에 대해 PSP는 책임을 지지
                않습니다.
              </span>
            </SSubContainer>
            <SSubContainer>
              <SSubNumberTitle>② 면책</SSubNumberTitle>
              <span>창작자는 다음과 같은 경우 PSP를 면책하고 배상할 의무가 있습니다:</span>
              <SListContainer direction="column">
                <span>1. 지적 재산권 침해</span>
                <span>2. 계정의 무단 사용</span>
                <span>3. 기밀 유지 의무 위반</span>
                <span>4. 본 약관, 이용약관, PSP의 운영 정책 위반</span>
              </SListContainer>
            </SSubContainer>
          </SSubWrapper>
        </div>
        <div>
          <SSubTitle>제10조: 분쟁 해결</SSubTitle>
          <SSubWrapper direction="column">
            <SSubContainer>
              <SSubNumberTitle>① 분쟁에 대한 중립적 입장</SSubNumberTitle>
              <span>
                PSP는 창작자 간의 수익 배분 청구나 컨텐츠 소유권에 대한 분쟁을 조정하지 않습니다. 이러한 분쟁은 외부
                중재 또는 법적 절차를 통해 해결해야 합니다.
              </span>
            </SSubContainer>
            <SSubContainer>
              <SSubNumberTitle>② 중재</SSubNumberTitle>
              <span>본 약관에서 발생하는 모든 분쟁은 PSP가 정한 중재 기관의 규정에 따라 해결됩니다.</span>
            </SSubContainer>
          </SSubWrapper>
        </div>
        <div>
          <SSubTitle>제11조: 종료 및 수정</SSubTitle>
          <SSubWrapper direction="column">
            <SSubContainer>
              <SSubNumberTitle>① 종료</SSubNumberTitle>
              <span>
                PSP는 중대한 약관 위반, 관련 법률 위반, 또는 7일 사전 통지 후 단독 재량으로 본 약관을 종료할 수
                있습니다. 특히 PSP는 이용약관 또는 운영정책에 위배되는 행위 발견시 해당 창작자에게 사전 통지 없이 이
                약관을 종료할 수 있습니다. 약관 종료 시점 이전 누적된 수익에 대해 PSP는 창작자에게 정산합니다.
              </span>
            </SSubContainer>
            <SSubContainer>
              <SSubNumberTitle>② 수정</SSubNumberTitle>
              <span>
                PSP는 7일 사전 통지 후 본 약관을 수정할 권리를 보유하며, 창작자는 새로운 조건을 수락하거나 PSP와의
                관계를 종료할 수 있습니다. 다만 창작자에게 불리한 약관 개정시 개정약관 적용일자 30일 전에 공지합니다.
              </span>
            </SSubContainer>
          </SSubWrapper>
        </div>
        <div>
          <SSubTitle>제12조: 준거법 및 관할권</SSubTitle>
          <SSubWrapper direction="column">
            본 약관은 대한민국 법률에 따라 규율됩니다. 중재를 통해 해결되지 않은 분쟁은 서울특별시 소재 법원의 전속
            관할권에 따릅니다.
          </SSubWrapper>
        </div>
        <div>
          <SSubTitle>제13조: 기타 규정</SSubTitle>
          <SSubWrapper direction="column">
            <SSubContainer>
              <SSubNumberTitle>① 약관의 완전성</SSubNumberTitle>
              <span>본 약관과 PSP의 이용 약관은 수익 배분에 관한 당사자 간의 완전한 이해를 구성합니다.</span>
            </SSubContainer>
            <SSubContainer>
              <SSubNumberTitle>② 권리 포기 없음</SSubNumberTitle>
              <span>PSP가 본 약관의 조항을 집행하지 않는 경우에도 이는 권리 포기로 간주되지 않습니다.</span>
            </SSubContainer>
            <SSubContainer>
              <SSubNumberTitle>③ 분리 가능성</SSubNumberTitle>
              <span>
                본 약관의 조항 중 일부가 무효이거나 집행 불가능한 경우, 나머지 조항은 여전히 완전한 효력을 유지합니다.
              </span>
            </SSubContainer>
          </SSubWrapper>
        </div>
      </SMainContainer>
    </SMainWrapper>
  );
}

const SMainContainer = styled.section`
  font-size: 14px;
  line-height: 1.6;
  color: #909090;
  background-color: #ffffff;
`;

const SSubTitle = styled.h5`
  font-size: 14px;
  font-weight: bold;
  margin-top: 40px;
  margin-bottom: 20px;
  color: #4b4b4b;
`;

const SSubNumberTitle = styled.h6`
  margin-bottom: 6px;
  font-size: 14px;
  font-weight: bold;
  color: #909090;
`;

const SSubWrapper = styled(Flex)`
  font-size: 14px;
  color: #909090;
  background-color: #ffffff;
`;
const SListContainer = styled(Flex)`
  margin-left: 14px;

  & > * + * {
    margin-top: 6px;
  }
`;

const SSubContainer = styled.div`
  & + & {
    margin-top: 16px;
  }
`;

const STableWrapper = styled.div`
  width: 100%;
  margin-top: 12px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
`;

/* && 로 명시도를 높여 공유 SMainWrapper 의 table(600px 고정·20px 패딩·가운데 정렬) 규칙을 덮어씀 */
const STable = styled.table`
  && {
    width: 100%;
    min-width: 460px;
    margin: 0;
    border-collapse: collapse;
    font-size: 13px;
    color: #909090;
  }

  caption {
    position: absolute;
    width: 1px;
    height: 1px;
    margin: -1px;
    padding: 0;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    white-space: nowrap;
    border: 0;
  }

  && th,
  && td {
    padding: 8px 10px;
    border: 1px solid #e5e5e5;
    font-size: 13px;
    text-align: left;
    vertical-align: top;
    word-break: keep-all;
  }

  && th {
    background-color: #f5f5f5;
    color: #4b4b4b;
    font-weight: bold;
  }
`;
